import React from 'react';
import { useTranslation } from 'react-i18next';

import { SelectButton } from '@weezevent/nacre';

import css from './pagination-dropdown.module.css';

const SelectedItemsActionsDropDown = ({ title, tooltip, selected = [], disabled = false, displaySelect = true, displayDropdown = true, items }) => {
    const { t } = useTranslation();

    const resolvedTitle = React.useMemo(() => {
        if (!selected.length > 0) {
            return t('common.action');
        }
        return title;
    }, [selected, title]);

    if (!displayDropdown && !displaySelect) {
        return null;
    }

    return (
        <div className={css['pagination-dropdown']}>
            <div className={css['pagination-dropdown-block']}>
                {displaySelect && (
                    <SelectButton tooltipTitle={tooltip} title={resolvedTitle} objects={selected} disabled={disabled}>
                        {items}
                    </SelectButton>
                )}
            </div>
        </div>
    );
};

export default SelectedItemsActionsDropDown;
